import { render, staticRenderFns } from "./orderManagment.vue?vue&type=template&id=762b99cf&scoped=true"
import script from "./orderManagment.vue?vue&type=script&lang=js"
export * from "./orderManagment.vue?vue&type=script&lang=js"
import style0 from "./orderManagment.vue?vue&type=style&index=0&id=762b99cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "762b99cf",
  null
  
)

export default component.exports